<template>
<div class="chat-meeting-bottom" :class="{'is-my': isMy}">
    <div class="chat-meeting-bottom__main">
        <span>{{ $t('chat.meeting.personalCode') }}:</span> <span>{{ code }}</span>
        <meeting-copy-button class="chat-meeting-bottom__copy" :value="code"/>
    </div>
    <div class="chat-meeting-bottom__sub">
        <span>{{ $t('chat.meeting.onlyYou') }}</span>
    </div>
</div>
</template>

<script>
import MeetingCopyButton from "@share/chat/components/chat/atachments/meeting/MeetingCopyButton";
export default {
    name: "MeetingAttachmentBottom",
    components: { MeetingCopyButton },
    props: {
        isMy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        code() {
            return this.$store.getters['profile']?.code;
        }
    }
}
</script>

<style scoped lang="scss">
.chat-meeting-bottom {
    max-width: 211px;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.016em;
    color: #D6D6D6;
    margin-top: 10px;
    text-align: left;
    padding: 0 0 0 10px;

    &__sub {
        font-size: 12px;
    }

    &__copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        position: relative;
        top: 1px;
    }

    &.is-my {
        margin-left: auto;
        padding: 0 10px 0 0;
    }
}
</style>
